import React from "react";

export default function EC_TextArea({ label, value, onChange, onFocusOut }) {
  return (
    <div className="flex h-full  rounded w-[100%] ">
      <div className=" text-[14px]">{label}</div>
      <div className="w-[100%] h-full">
        <textarea
          className="w-[100%] h-full  resize-none bg-[#212226] outline-none rounded text-white p-2 font-thin"
          value={value}
          onChange={(e) => {
            onChange(e.target.value);
          }}
          onBlur={onFocusOut}
        />
      </div>
    </div>
  );
}
